import { PencilSimple } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useUserPermissions } from 'auth/hooks';
import { Button } from 'core/components';
import { AccessPermissions } from 'core/enums';
import { IPart } from 'parts/types';

import { EditPartParticulars } from './EditPartParticulars';

interface IProps {
  part?: IPart | null;
}

export const EditPartParticularsButton = ({ part }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();
  const { hasPermission } = useUserPermissions();

  const isEditable =
    hasPermission(AccessPermissions.PARTS_EDIT_SAVE_PARTICULARS) &&
    !part?.familyId &&
    part?.manufacturerId != null;

  if (!isEditable) {
    return null;
  }

  return (
    <>
      <Button
        startDecorator={<PencilSimple />}
        text={t('buttonLabelEditParticulars')}
        onClick={() => setIsOpen(true)}
      />
      <EditPartParticulars part={part} isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};
